
export function AboutSection() {
  const advantages = [
    'Deutschlandweite Lieferung',
    'Individuelle Maßanfertigung',
    'Kurze Produktionszeiten',
    'UV-beständiger Qualitätsdruck'
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Images */}
          <div className="space-y-6">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/b25bc00e4634759629142b23802211eb.jpg"
                alt="Produktionshalle Horizon Signage"
                className="w-full h-64 object-cover rounded-2xl shadow-lg"
              />
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=close-up%20detail%20of%20high-quality%20fabric%20printing%20process%20for%20promotional%20banners%2C%20professional%20textile%20printing%20with%20vibrant%20colors%20and%20sharp%20details%2C%20commercial%20flag%20production%20quality%20control%20and%20inspection&width=600&height=300&seq=about-quality-001&orientation=landscape"
                alt="Druckqualität Detail"
                className="w-full h-64 object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:pl-8">
            <div className="mb-8">
              <span className="inline-block px-4 py-2 bg-gray-100 text-zinc-800 rounded-full text-sm font-semibold uppercase tracking-wider mb-6">
                Über Horizon Signage
              </span>
              <h2 className="text-4xl lg:text-5xl font-bold text-zinc-800 leading-tight mb-6">
                <span className="block">Qualität und</span>
                <span className="block">Zuverlässigkeit</span>
                <span className="block text-gray-600">seit über 15 Jahren</span>
              </h2>
            </div>

            <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
              <p>
                Als führender Anbieter für professionelle Promotion-Fahnen und visuelle 
                Außenwerbung stehen wir für höchste Qualität und maßgeschneiderte Lösungen 
                im B2B-Bereich.
              </p>
              <p>
                Unsere langjährige Erfahrung in der Werbetechnik und unser Fokus auf 
                innovative Produktionsverfahren garantieren Ihnen Werbeprodukte, die 
                auch unter extremen Witterungsbedingungen zuverlässig funktionieren.
              </p>
              <p>
                Von der ersten Beratung bis zur termingerechten Lieferung begleiten wir 
                Sie mit kompetenter Beratung und flexiblen Lösungen für Ihre individuellen 
                Anforderungen.
              </p>
            </div>

            {/* Advantages List */}
            <div className="mt-10">
              <ul className="space-y-4">
                {advantages.map((advantage, index) => (
                  <li key={index} className="flex items-center">
                    <div className="w-6 h-6 flex items-center justify-center bg-green-500 rounded-full mr-4 flex-shrink-0">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <span className="text-lg font-medium text-zinc-800">{advantage}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Statistics */}
            <div className="mt-12 grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-zinc-800 mb-2">500+</div>
                <div className="text-sm text-gray-600">Zufriedene Kunden</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-zinc-800 mb-2">15+</div>
                <div className="text-sm text-gray-600">Jahre Erfahrung</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-zinc-800 mb-2">48h</div>
                <div className="text-sm text-gray-600">Express-Service</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
